import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_StartExpenseAnalysisCommand, se_StartExpenseAnalysisCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class StartExpenseAnalysisCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Textract", "StartExpenseAnalysis", {})
    .n("TextractClient", "StartExpenseAnalysisCommand")
    .f(void 0, void 0)
    .ser(se_StartExpenseAnalysisCommand)
    .de(de_StartExpenseAnalysisCommand)
    .build() {
}
